import { QueryFunctionContext } from "react-query";
import { useAuthStore } from "../store";
import idServerApi from "./idServerApi";

export async function checkHeartBeat() {
  return idServerApi
    .get("auth/heartbeat")
    .then((res: any) => res.data)
    .catch((err: any) => {
      if (err?.response?.data?.status === 403) {
        sessionStorage.clear();
        useAuthStore.getState().clear();
        const redirectUrl = generateRedirectUrl();
        if (window.location.hostname !== "localhost")
          window.location.href = redirectUrl;
      }
    });
}

export async function refetchAccessToken(): Promise<string> {
  return idServerApi
    .get("auth/token")
    .then((res: any) => res.data.data)
    .catch((err: any) => {
      if (err?.response?.data?.status === 403) {
        const redirectUrl = generateRedirectUrl();
        if (window.location.hostname !== "localhost")
          window.location.href = redirectUrl;
      }
    });
}

export async function signOut(
  data: any
): Promise<{ message: string; data: string }> {
  return idServerApi
    .post(`auth/logout`, undefined)
    .then((res: any) => res.data);
}

export async function getPlatformInfo(
  context: QueryFunctionContext
): Promise<any> {
  const accesstoken = context.queryKey[1] as string;
  return idServerApi
    .get(`auth/user/platform`, {
      headers: {
        accesstoken,
      },
    })
    .then((res: any) => res.data.data);
}

export function generateRedirectUrl() {
  const redirectUrl = encodeURIComponent(window.location.href);
  const baseUrl = (
    process.env.REACT_APP_ID_SERVER_CLIENT_URL ??
    "https://identity.dev.hissa.com"
  ).replace(/\/+$/, "");
  const url = `${baseUrl}/login?redirect=${redirectUrl}&platform=esop`;
  return url;
}
